// import { toast } from 'react-toastify';
import { Provider, CachePolicies } from 'use-http';
const HttpProvider = ({ children }) => {
    const API_URL = process.env.REACT_APP_API_SURVEY_URL;
    const options = {
        cacheLife: 0,
        cachePolicy: CachePolicies.NO_CACHE, // 'no-cache'
        interceptors: {
            request: async ({ options, url, path, route }) => {
                // `async` is not required
                // This app is respondent-facing and usually has no signed-in user at all. The
                // OIDC entry is only ever present when it happens to share an origin with the
                // portal (true on GCP, false on AWS), so treat it as a bonus, not a
                // requirement, and send no header rather than a literal "Bearer undefined" -
                // which is what made the AWS template preview's 401 so hard to read.
                let admin = null;
                try {
                    admin = JSON.parse(
                        localStorage.getItem(
                            `oidc.user:${process.env.REACT_APP_Identity_URL}:${process.env.REACT_APP_CLIENT}`
                        )
                    );
                } catch (e) {
                    admin = null;
                }

                if (admin?.id_token) {
                    options.headers.authorization = 'Bearer ' + admin.id_token;
                }
                return options; // returning the `options` is important
            },
            response: async ({ response }) => {
                //console.log({ response })
                //      toast.success(response.data.message);
                return response; // returning the `response` is important
            }
        },
        loading: false,
        onAbort: () => {},
        onError: ({ error }) => {
            console.log({ error });
        },
        onTimeout: () => {},
        persist: false,
        retries: 3,
        retryDelay: 10000,
        retryOn: [503],
        suspense: false,
        timeout: 6000000
    };

    return (
        <Provider url={API_URL} options={options}>
            {children}
        </Provider>
    );
};

export default HttpProvider;
